module.exports = __webpack_public_path__ + "static/media/developer-centerpublic-api-svgrepo-com (2).76c0b816.svg";